<div class="filter-container">

  <form [formGroup]="FilterComponentForm">

    <div class="row">
      <div class="col col-sm-12 col-md-9 col-lg-8">

        <div class="search-policy-filter">

          <mat-card appearance="outlined" class="search-box-filter">
            <div class="row m-0">
              <div class="col-4 p-0">
                <mat-form-field class="search-policy-select-filter w-100">
                  <mat-label class="mat-label-filter">{{ searchTypeLabelText }}</mat-label>
                  <mat-select matSelect (selectionChange)="onSelectFilterEvent($event)" [(value)]="searchType">
                    <mat-option class="mat-option-filter" *ngFor="let filter of filterConfiguration.filterTypes"
                      [value]="filter">
                      {{ filter }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-8 p-0">
                <div class="row m-0">
                  <div class="col-10 col-sm-11 p-0 pl-3" style="height: 48px;">
                    <mat-form-field class="w-100">
                      <input matInput formControlName="filterInput" />
                    </mat-form-field>
                  </div>
                  <div class="col-2 col-sm-1 p-0">
                    <div class="search-icon">
                      <mat-icon>search</mat-icon>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
      <div class="col pt-4 pt-sm-0 col-sm-12 col-md-3 col-lg-4">

        <div class="btn-container btn-container-filter">
          <button *ngIf="displayClearButton" class="btn btn-light btn-secondary  btn-filter" (click)="onCancel($event)">
            {{ filterConfiguration.clearButtonText }}
          </button>

          <button *ngIf="!displayClearButton" class="btn btn-primary btn-filter btn-secondary-filter"
            [disabled]="!isValid()"
            (click)="onClickSearchEvent()">{{ filterConfiguration.searchButtonText }}</button>
        </div>


      </div>
    </div>
  </form>
</div>
